import React from 'react';
import styled from 'styled-components';
import { GlobalStyle } from 'globalStyles';
import { colors } from 'constants/colors';
import Header from 'Components/Header/HeaderContainer';
import LogoIcon from 'Components/Header/Logo/LogoIcon';
import Box from 'Components/Grid/Box';
import Flex from 'Components/Grid/Flex';
import Title from 'Components/Typography/Title';
import mascot from 'assets/images/igooods-mascot.png';
import chrome from 'assets/images/browsers/chrome.png';
import opera from 'assets/images/browsers/opera.png';
import firefox from 'assets/images/browsers/firefox.png';
import { currentWLabel, selectByWL } from 'utils/wLabel';
import { WLabel } from 'constants/enums';
import { useUserAgentContext } from 'utils/userAgent/context';
import { mediaSmDown } from 'theme/helpers/css';

const Container = styled.div`
  height: 100vh;
  background-color: ${colors.paleGreySix};
`;

const StyledHeader = styled(Header)`
  background-color: ${colors.paleGreySix};
  box-shadow: none;
  position: relative;
  padding: 0 24px;

  ${mediaSmDown`
    padding: 0 16px;
  `}
`;

const Content = styled(Flex).attrs({
  middle: true,
  center: true,
  column: true,
})`
  margin-top: 110px;
`;

const MascotImage = styled.img`
  min-height: 100px;
`;

const Message = styled.div`
  max-width: 640px;
  text-align: center;
  line-height: 24px;
`;

const Browsers = styled(Flex).attrs({
  middle: true,
  between: true,
})`
  min-width: 325px;
`;

const wlBrowsersLinkStyles = selectByWL({
  [WLabel.Default]: `color: ${colors.darkBlueGreen};`,
  [WLabel.Globus]: `color: ${colors.simpleOrange};`,
});

const BrowsersLink = styled.a`
  display: flex;
  align-items: center;
  flex-direction: column;
  text-decoration: none;
  ${wlBrowsersLinkStyles}
`;

const BrowserIcon = styled.img`
  min-height: 61px;
`;

const browsers = [
  { name: 'Chrome', link: 'https://www.google.com/chrome/', image: chrome },
  { name: 'Opera', link: 'https://www.opera.com/', image: opera },
  { name: 'Firefox', link: 'https://www.mozilla.org/', image: firefox },
];

export const IEPage: React.FC = () => (
  <Container>
    <StyledHeader>
      <LogoIcon mr={2} />
    </StyledHeader>
    <Content>
      {currentWLabel === WLabel.Default && (
        <Box mb={5}>
          <MascotImage src={mascot} />
        </Box>
      )}

      <Box mb={5}>
        <Title>Ваш браузер устарел</Title>
      </Box>
      <Box mb={15}>
        <Message>
          Мы&nbsp;отказались от&nbsp;поддержки Internet Explorer, так как это может быть причиной медленной работы и
          непредвиденных ошибок. Для комфортного использования установите последнюю версию одного из&nbsp;браузеров:
        </Message>
      </Box>
      <Browsers>
        {browsers.map(browser => (
          <BrowsersLink key={browser.name} href={browser.link}>
            <Box mb={3}>
              <BrowserIcon src={browser.image} />
            </Box>
            {browser.name}
          </BrowsersLink>
        ))}
      </Browsers>
    </Content>
  </Container>
);

const IECheck: React.FC<{ children: React.ReactChild | React.ReactNode }> = ({ children }) => {
  const { isIE } = useUserAgentContext();

  return isIE ? (
    <>
      <GlobalStyle />
      <IEPage />
    </>
  ) : (
    <>{children}</>
  );
};

export default IECheck;
